import * as React from "react";
/**
 * View context
 */ export const ViewContext = React.createContext({
    isLabelCollapsed: false
});
